export const removeUndefinedFromObject = (obj) => {
  let newObj = {}
  Object.keys(obj).forEach((key) => {
    const value = obj[key]
    if (value != null) newObj[key] = value
  })
  return newObj
}
